import { Question } from "@phosphor-icons/react";

// One-line explanation of how a figure is calculated. Native title keeps it
// dependency-free and works on every screen.
export const InfoHint = ({ text, testid }) => (
  <span title={text} className="inline-flex align-middle cursor-help text-muted-foreground/70 hover:text-primary" data-testid={testid}>
    <Question size={12} />
  </span>
);

export const RECOGNITION_HINTS = {
  booked: "Booked revenue: everything sold in this period — bookings whose booking date falls here, in any status except cancelled or sent back. Sales activity, not money earned.",
  earned: "Earned revenue: bookings whose rental period ended in this period and are Current, Completed or Paid out. A booking is earned when the rental ends. This is the primary revenue figure.",
  collected: "Collected cash: money actually received in this period — deposits recorded on bookings plus payments recorded against invoices.",
};
